<nz-spin [nzSize]="'small'" [nzSpinning]="loading">
  <div class="grid md:grid-cols-1">
    <div>
      <nz-select
        nzShowSearch
        nzServerSearch
        [nzPlaceHolder]="'itineraries.destination.form.searchDestination' | transloco"
        [(ngModel)]="selectedDest"
        [nzShowArrow]="false"
        (nzOnSearch)="searchDestination($event)"
        (ngModelChange)="selectedDestination(selectedDest)">
        <nz-option
          nzCustomContent
          *ngFor="let option of listOfOption"
          [nzLabel]="option.placePrediction.text.text"
          [nzValue]="option.placePrediction">
          <div class="flex justify-start items-center">
            <div class="mr-2">
              <lucide-icon
                class="search-icons flex"
                name="{{ this.getIcon(option.placePrediction) }}"></lucide-icon>
            </div>
            <div>
              {{ option.placePrediction.text.text }}
            </div>
          </div>
        </nz-option>
      </nz-select>
    </div>
    <nz-divider></nz-divider>
    <h5 class="mb-3">{{ this.title }}</h5>
    <div>
      <nz-alert
        nzType="info"
        nzShowIcon
        [nzMessage]="'itineraries.destination.form.uploadHdImageInfo' | transloco"></nz-alert>
    </div>
    <div class="mt-5 grid md:grid-cols-12 gap-5">
      <div class="md:col-span-4">
        <form nz-form [formGroup]="featuredForm">
          <div>
            <div class="grid grid-cols-1">
              <div
                class="relative w-full aspect-[1517/769]"
                *ngIf="
                  this.getSelectedImage() !== '' &&
                  this.getSelectedImage() !== undefined
                ">
                <!-- Image positioner: drag to reposition, scroll to zoom -->
                <app-image-positioner
                  [imageSrc]="getSelectedImage()"
                  [state]="currentImagePosition"
                  [aspectRatio]="'1517 / 769'"
                  (stateChange)="onImagePositionChange($event)">
                </app-image-positioner>
                <button
                  nz-button
                  nzType="default"
                  class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white/80 backdrop-blur-sm p-2 rounded-full shadow"
                  style="z-index: 10"
                  (click)="removeSelectedImage()">
                  <i nz-icon nzType="delete" nzTheme="outline"></i>
                </button>
              </div>
            </div>

            <div class="grid grid-cols-1">
              <nz-radio-group
                class="my-3 grid grid-cols-4 md:grid-cols-3 justify-items-center"
                nzButtonStyle="solid"
                [ngModel]="featuredForm.get('image')?.value"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="featuredForm.patchValue({ image: $event })">
                <label
                  class="w-16 h-16 md:w-12 md:h-12 p-1 mb-2"
                  *ngFor="let img of getUploadImages()"
                  nz-radio-button
                  [nzValue]="img">
                  <img class="w-full h-full object-cover" [src]="img" alt="" />
                  <span
                    nz-popconfirm
                    [nzPopconfirmTitle]="'itineraries.destination.form.deleteImageConfirm' | transloco"
                    nzPopconfirmPlacement="top"
                    [nzOkText]="'itineraries.modals.delete.ok' | transloco"
                    [nzCancelText]="'itineraries.modals.common.cancel' | transloco"
                    (nzOnConfirm)="deleteImage(img)"
                    (nzOnCancel)="cancel()"
                    class="text-[#F96074] cursor-pointer flex justify-center mt-2">
                    <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
                  </span>
                </label>
              </nz-radio-group>
              <div class="mb-2">
                <p
                  class="text-danger text-sm"
                  *ngIf="formErrors.image.required">
                  {{ 'itineraries.destination.form.errors.imageRequired' | transloco }}
                </p>
                <p
                  class="text-danger text-sm"
                  *ngIf="this.featuredForm.controls.image.status === 'INVALID'">
                  {{ 'itineraries.destination.form.errors.imageTileRequired' | transloco }}
                </p>
              </div>
            </div>
          </div>
          <div *ngIf="!this.isImageExist">
            <nz-upload
              class="custom-upload-size-modal-content"
              [(nzFileList)]="fileList"
              [nzShowButton]="fileList.length < 8"
              [nzPreview]="handlePreview"
              [nzCustomRequest]="customUploadReq"
              (nzChange)="handleChange($event)"
              nzListType="picture-card"
              nzAccept="image/png,image/jpg,image/jpeg"
              [nzHeaders]="setMediaUploadHeaders"
              [nzRemove]="onRemove"
              [nzShowUploadList]="false">
              <div>
                <span nz-icon nzType="upload" nzTheme="outline"></span>
              </div>
            </nz-upload>
          </div>
          <div *ngIf="this.isImageExist">
            <nz-upload
              [(nzFileList)]="fileList"
              [nzShowButton]="fileList.length < 8"
              [nzCustomRequest]="customUploadReq"
              (nzChange)="handleChange($event)"
              nzAccept="image/png,image/jpg,image/jpeg"
              [nzHeaders]="setMediaUploadHeaders"
              [nzRemove]="onRemove"
              [nzShowUploadList]="false">
              <div class="mt-3">
                <p>
                  <span class="me-2" nz-icon nzType="upload"></span>
                  <a>{{ 'itineraries.destination.form.clickToUploadMore' | transloco }}</a>
                </p>
              </div>
            </nz-upload>
          </div>
        </form>
        <form nz-form [formGroup]="featuredForm">
          <div *ngIf="this.destinationDTO.images.length !== 0 && type !== 'new'">
            <h5 class="mt-3">{{ 'itineraries.destination.form.sharedContent' | transloco }}</h5>
            <div class="grid grid-cols-1">
              <nz-radio-group
                class="my-3 grid grid-cols-4 md:grid-cols-3 justify-items-center"
                nzButtonStyle="solid"
                [ngModel]="featuredForm.get('image')?.value"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="featuredForm.patchValue({ image: $event })">
                <label
                  class="w-16 h-16 md:w-12 md:h-12 p-1 mb-2"
                  *ngFor="let img of images"
                  nz-radio-button
                  [nzValue]="img">
                  <img class="w-full h-full object-cover" [src]="img" alt="" />
                </label>
              </nz-radio-group>
              <div class="mb-2">
                <p
                  class="text-danger text-sm"
                  *ngIf="formErrors.image.required">
                  {{ 'itineraries.destination.form.errors.imageRequired' | transloco }}
                </p>
                <p
                  class="text-danger text-sm"
                  *ngIf="this.featuredForm.controls.image.status === 'INVALID'">
                  {{ 'itineraries.destination.form.errors.imageTileRequired' | transloco }}
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="md:col-span-8">
        <form nz-form [formGroup]="featuredForm">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="descriptionCheck">
              <quill-editor class="w-full h-52" formControlName="body">
                <div quill-editor-toolbar>
                  <div class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                  </div>
                </div>
              </quill-editor>
            </nz-form-control>
            <ng-template #descriptionCheck>
              <span *ngIf="formErrors.body?.required">
                {{ 'itineraries.destination.form.errors.descriptionRequired' | transloco }}
              </span>
            </ng-template>
          </nz-form-item>
          <div *ngIf="isDisplayAiButton" class="flex justify-end my-3">
            <button
              class="ai-button flex items-center"
              nz-button
              nzType="default"
              (click)="
                getGeneratedContent({
                  name: this.title,
                  language: this.itinerary.tour.language
                })
              ">
              <span nz-icon nzType="plus"></span>
              {{ 'itineraries.destination.form.quickGenerate' | transloco }}
            </button>
          </div>
          <div>
            <nz-radio-group
              class="my-3 flex flex-wrap custom-radio-radius"
              nzButtonStyle="solid"
              formControlName="keyword">
              <label
                class="mr-3 mb-3"
                *ngFor="let text of this.contexts"
                [(ngModel)]="radioValue"
                [ngStyle]="
                  text.keyword === 'Custom'
                    ? { 'background-color': '#F5F5F5', color: '#222' }
                    : {}
                "
                nz-radio-button
                (click)="selectedKeyword(text.body)"
                [nzValue]="text.keyword">
                {{ text.keyword }}
              </label>
            </nz-radio-group>
            <div>
              <p
                class="text-danger text-sm"
                *ngIf="formErrors.keyword?.required">
                {{ 'itineraries.destination.form.errors.keywordRequired' | transloco }}
              </p>
            </div>
          </div>
        </form>
      </div>
      <div class="md:col-span-12">
        <nz-divider></nz-divider>
        <nz-select
          nzMode="tags"
          [nzPlaceHolder]="'itineraries.destination.form.selectDays' | transloco"
          [nzShowArrow]="true"
          nzAllowClear
          [(ngModel)]="listOfTagOptions">
          <nz-option
            *ngFor="let option of this.itinerary.days; let i = index"
            [nzLabel]="
              !itinerary.tour.isDatesOptional
                ? 'Day ' + (i + 1) + ' - ' + (option.date | date : 'dd/MM/yyyy')
                : 'Day ' + (i + 1)
            "
            [nzValue]="i"></nz-option>
        </nz-select>

        <div class="mt-1" *ngIf="listOfTagOptions.length === 0">
          <p class="text-danger text-sm" style="font-size: 0.85rem">
            {{ 'itineraries.destination.form.errors.dateRequired' | transloco }}
          </p>
        </div>
      </div>
      <div
        class="md:col-span-12"
        *ngIf="this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT">
        <nz-alert
          nzType="warning"
          [nzMessage]="'itineraries.destination.form.editWarning' | transloco"
          nzShowIcon>
        </nz-alert>
      </div>
    </div>
  </div>
</nz-spin>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">{{ 'itineraries.destination.form.close' | transloco }}</button>
  <button
    nz-button
    nzType="primary"
    (click)="determineMerge(this.listOfTagOptions)"
    [nzLoading]="this.isButtonLoading"
    [disabled]="
      !this.featuredForm.valid ||
      this.googlePlaceDetails === undefined ||
      this.listOfTagOptions.length === 0
    ">
    {{ this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT ? ('itineraries.destination.form.edit' | transloco) : ('itineraries.destination.form.add' | transloco) }}
  </button>
</div>
